// added by plop
import { UnknownError } from 'symbols';
import { CheckConfirmCodeModel, LoginData, RegistrationData, ResetPasswordModel } from '../../symbols';

export class Login {
  static type = '[auth] Login';

  constructor(public data: LoginData) {
  }
}


export class LoginSuccess {
  static type = '[auth] LoginSuccess';

  constructor(public token: string) {
  }
}


export class LoginFail {
  static type = '[auth] LoginFail';

  constructor(public error: UnknownError) {
  }
}

// added by plop
export class Logout {
  static type = '[auth] Logout';

}


export class LogoutSuccess {
  static type = '[auth] LogoutSuccess';

}


export class LogoutFail {
  static type = '[auth] LogoutFail';

  constructor(public error: UnknownError) {
  }
}

export class ResetAuthState {
  static type = '[auth] ResetAuthState';
}

export class Registration {
  static type = `[auth] ${Registration.name}`;

  constructor(public data: RegistrationData, public token: string) {
  }
}


export class RegistrationSuccess {
  static type = `[auth] ${RegistrationSuccess.name}`;

  constructor(public data: RegistrationData) {
  }
}


export class RegistrationFail {
  static type = `[auth] ${RegistrationFail.name}`;

  constructor(public error: UnknownError) {
  }
}


export class CheckUserExist {
  static type = '[auth] CheckUserExist';

  constructor(public tel: string) {
  }
}

export class CheckUserExistSuccess {
  static type = '[auth] CheckUserExistSuccess';

  constructor(public isExist: boolean) {
  }
}

export class CheckUserExistFail {
  static type = '[auth] CheckUserExistFail';

  constructor(public error: UnknownError) {
  }
}

export class CheckTelegramBotExist {
  static type = '[auth] CheckTelegramBotExist';

  constructor(public tel: string) {
  }
}

export class CheckTelegramBotExistSuccess {
  static type = '[auth] CheckTelegramBotExistSuccess';

  constructor(public isExist: boolean) {
  }
}

export class CheckTelegramBotExistFail {
  static type = '[auth] CheckTelegramBotExistFail';

  constructor(public error: UnknownError) {
  }
}


export class GetConfirmRegistrationCodeToTelegramBot {
  static type = `[auth] ${GetConfirmRegistrationCodeToTelegramBot.name}`;

  constructor(public tel: string) {
  }
}

export class GetConfirmRegistrationCodeToTelegramBotSuccess {
  static type = `[auth] ${GetConfirmRegistrationCodeToTelegramBotSuccess.name}`;
}

export class GetConfirmRegistrationCodeToTelegramBotFail {
  static type = `[auth] ${GetConfirmRegistrationCodeToTelegramBotFail.name}`;

  constructor(public error: UnknownError) {
  }
}


export class GetTelegramBotLink {
  static type = '[auth] GetTelegramBotLink';
}

export class NewTelegramBotWs {
  static type = '[auth] NewTelegramBotWs';

  constructor(public payload: { [tel: string]: boolean }) {
  }
}

export class CheckConfirmCode {
  static type = `[auth] ${CheckConfirmCode.name}`;

  constructor(public data: CheckConfirmCodeModel) {
  }
}

export class CheckConfirmCodeSuccess {
  static type = '[auth] CheckConfirmCodeSuccess';

  constructor(public token: string) {
  }
}

export class CheckConfirmCodeFail {
  static type = '[auth] CheckConfirmCodeFail';

  constructor(public error: UnknownError) {
  }
}


export class CheckResetPasswordCode {
  static type = `[auth] ${CheckResetPasswordCode.name}`;

  constructor(public data: CheckConfirmCodeModel) {
  }
}

export class CheckResetPasswordCodeSuccess {
  static type = '[auth] CheckResetPasswordCodeSuccess';

  constructor(public token: string) {
  }
}

export class CheckResetPasswordCodeFail {
  static type = '[auth] CheckResetPasswordCodeFail';

  constructor(public error: UnknownError) {
  }
}

export class ResetPassword {
  static type = '[auth] ResetPassword';

  constructor(public data: ResetPasswordModel, public token: string) {
  }
}

export class ResetPasswordSuccess {
  static type = '[auth] ResetPasswordSuccess';
}

export class ResetPasswordFail {
  static type = '[auth] ResetPasswordFail';

  constructor(public error: UnknownError) {
  }
}

export class InactivateAccount {
  static type = '[auth] InactivateAccount';
}

export class InactivateAccountSuccess {
  static type = '[auth] InactivateAccountSuccess';
}

